import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { ConfirmModalModule } from 'Angular/features/components/modals/confirm-modal/confirm-modal.module';
import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';
import { TextEditModule } from 'Angular/features/components/modals/text-edit/text-edit.module';
import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { IndexOfPipeModule } from 'Angular/features/pipes/index-of/index-of-pipe.module';
import { AutocompleteInPlaceModule } from 'SearchApp/ts/features/autocomplete-in-place/autocomplete-in-place.module';
import * as i0 from "@angular/core";
export class TalkingPointsEditModalModule {
}
TalkingPointsEditModalModule.ɵfac = function TalkingPointsEditModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TalkingPointsEditModalModule)(); };
TalkingPointsEditModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: TalkingPointsEditModalModule });
TalkingPointsEditModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [AutocompleteInPlaceModule,
        BrowserModule,
        CommonModule,
        ConfirmModalModule,
        DisabledModule,
        FormsModule,
        IconModule,
        IndexOfPipeModule,
        ModalBaseModule,
        TextEditModule] });
